import React, { useState } from "react";
import { BreadCrumb } from "primereact/breadcrumb";
import { Button } from "primereact/button";
import { useLocation, useParams, Link } from "react-router-dom";
import Panel from "../../../../components/panel/panel";
import "./styleFeasibility.css";
import { Dialog } from "primereact/dialog";

const FeasibilityStudy = () => {
  const { id } = useParams();
  const { state } = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [modalInfo, setModalInfo] = useState({ label: "", value: "" });
  const [activeStep, setActiveStep] = useState(1);

  const items = [
    {
      template: () => (
        <Link
          to={`/enterpriseSettings/${id}`}
          state={{ name: state?.name || "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Configurações do Empreendimento
        </Link>
      ),
    },
    {
      template: () => (
        <Link
          to={`/feasibilityStudy/${id}`}
          state={{ name: state?.name || "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Estudo de Viabilidade
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to="/salesManagement" className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const etapas = Array.from({ length: 5 }, (_, i) => i + 1);

  const [dadosEtapa, setDadosEtapa] = useState({
    areaTotal: "510",
    coeficiente: "80",
    areaUtil: "6551",
    tamanhoMedio: "300",
    qtdLotes: "30",
    precoLote: "120.000",
  });

  return (
    <div className="p-2">
      <BreadCrumb
        model={items}
        home={home}
        style={{ background: "transparent", border: "none", fontSize: "16px" }}
      />
      {/* Etapas */}
      <div
        className="w-100 px-2 d-flex flex-wrap justify-content-start gap-2 mt-4 mb-4 fw-bold"
        style={{ fontFamily: "Axiforma, sans serif" }}
      >
        {etapas.map((etapa) => (
          <button
            key={etapa}
            onClick={() => setActiveStep(etapa)}
            className={`btn ${
              activeStep === etapa ? "btn-primary" : "btn-secondary"
            } rounded-pill px-4 py-2 w-auto`}
          >
            ETAPA {etapa}
          </button>
        ))}
      </div>
      <div className="row">
        <div
          className="col-12 mb-3 p-2"
          style={{ fontFamily: "Axiforma, sans-serif" }}
        >
          <Panel header="Primeiro Bloco" className="w-100">
            <div className="row py-3">
              <div className="col-md-4 mb-5 mb-md-0 d-flex align-items-center justify-content-center custom-border-end">
                <div>
                  <p className="mb-2 fw-light fs-5 text-center">
                    Área total do terreno
                  </p>
                  <div className="d-flex flex-row align-items-center justify-content-center gap-3">
                    <i
                      className="pi pi-pencil"
                      style={{ color: "#348fe2", cursor: "pointer" }}
                      onClick={() => {
                        setModalInfo({
                          label: "Área total do terreno",
                          key: "areaTotal",
                          value: dadosEtapa.areaTotal,
                        });
                        setShowModal(true);
                      }}
                    ></i>
                    <h1
                      className="m-0 fw-bold text-center"
                      style={{ fontFamily: "Axiforma, sans-serif" }}
                    >
                      {dadosEtapa.areaTotal}m²
                    </h1>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mb-5 mb-md-0 d-flex align-items-center justify-content-center custom-border-end">
                <div>
                  <p className="mb-2 fs-5 text-center">Área útil</p>
                  <div className="d-flex flex-row align-items-center justify-content-center gap-3">
                    <i
                      className="pi pi-pencil"
                      style={{ color: "#348fe2", cursor: "pointer" }}
                      onClick={() => {
                        setModalInfo({
                          label: "Área útil",
                          key: "areaUtil",
                          value: dadosEtapa.areaUtil,
                        });
                        setShowModal(true);
                      }}
                    ></i>
                    <h1
                      className="m-0 text-center"
                      style={{ fontFamily: "Axiforma, sans-serif" }}
                    >
                      {dadosEtapa.areaUtil}m²
                    </h1>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mb-0 mb-md-0 d-flex align-items-center justify-content-center">
                <div>
                  <p className="mb-2 fs-5 text-center">
                    Coeficiente de aproveitamento
                  </p>
                  <div className="d-flex flex-row align-items-center justify-content-center gap-3">
                    <i
                      className="pi pi-pencil"
                      style={{ color: "#348fe2", cursor: "pointer" }}
                      onClick={() => {
                        setModalInfo({
                          label: "Coeficiente de aproveitamento",
                          key: "coeficiente",
                          value: dadosEtapa.coeficiente,
                        });
                        setShowModal(true);
                      }}
                    ></i>
                    <h1
                      className="m-0 text-center"
                      style={{ fontFamily: "Axiforma, sans-serif" }}
                    >
                      {dadosEtapa.coeficiente}%
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </Panel>
        </div>

        {/* Segundo Panel com 3 colunas */}
        <div className="col-12">
          <Panel header="Segundo Bloco" className="w-100">
            <div className="row p-3">
              <div className="col-md-4 mb-5 mb-md-0 d-flex align-items-center justify-content-center custom-border-end">
                <div>
                  <p className="mb-2 fs-5 text-center">
                    Tamanho médio dos lotes
                  </p>
                  <div className="d-flex flex-row align-items-center justify-content-center gap-3">
                    <i
                      className="pi pi-pencil"
                      style={{ color: "#348fe2", cursor: "pointer" }}
                      onClick={() => {
                        setModalInfo({
                          label: "Tamanho médio dos lotes",
                          key: "tamanhoMedio",
                          value: dadosEtapa.tamanhoMedio,
                        });
                        setShowModal(true);
                      }}
                    ></i>
                    <h1
                      className="m-0 text-center"
                      style={{ fontFamily: "Axiforma, sans serif" }}
                    >
                      {dadosEtapa.tamanhoMedio}m²
                    </h1>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mb-5 mb-md-0 d-flex align-items-center justify-content-center custom-border-end">
                <div>
                  <p className="mb-2 fs-5 text-center">
                    Qntde de lotes (estimado)
                  </p>
                  <div className="d-flex flex-row align-items-center justify-content-center gap-3">
                    <i
                      className="pi pi-pencil"
                      style={{ color: "#348fe2", cursor: "pointer" }}
                      onClick={() => {
                        setModalInfo({
                          label: "Qntde de lotes (estimado)",
                          key: "qtdLotes",
                          value: dadosEtapa.qtdLotes,
                        });
                        setShowModal(true);
                      }}
                    ></i>
                    <h1
                      className="m-0 text-center"
                      style={{ fontFamily: "Axiforma, sans serif" }}
                    >
                      {dadosEtapa.qtdLotes}
                    </h1>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mb-0 mb-md-0 d-flex align-items-center justify-content-center">
                <div>
                  <p className="mb-2 fs-5 text-center">
                    Preço estimado por lote
                  </p>
                  <div className="d-flex flex-row align-items-center justify-content-center gap-3">
                    <i
                      className="pi pi-pencil"
                      style={{ color: "#348fe2", cursor: "pointer" }}
                      onClick={() => {
                        setModalInfo({
                          label: "Preço estimado por lote",
                          key: "precoLote",
                          value: dadosEtapa.precoLote,
                        });
                        setShowModal(true);
                      }}
                    ></i>
                    <h1
                      className="m-0 text-center"
                      style={{ fontFamily: "Axiforma, sans serif" }}
                    >
                      {dadosEtapa.precoLote}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </Panel>
        </div>
      </div>
      {/* Próxima etapa */}
      <div className="mt-3 d-flex justify-content-end">
        <Button
          label="PRÓXIMA ETAPA"
          className="rounded-5 w-25 p-button-primary fs-5"
        />
      </div>
      <Dialog
        header={
          <span style={{ fontFamily: "Axiforma, sans-serif" }}>
            <span style={{ fontWeight: 300 }}>Etapa {activeStep}:</span>{" "}
            <strong>{modalInfo.label}</strong>
          </span>
        }
        visible={showModal}
        style={{ width: "100%", maxWidth: "500px" }}
        onHide={() => setShowModal(false)}
      >
        <div>
          <hr className="mt-0 mb-3" />

          <p
            className="text-muted fst-italic mb-4"
            style={{ fontSize: "0.8rem" }}
          >
            Clique no número para editar.
          </p>

          <div className="d-flex justify-content-center align-items-center gap-4 mb-1">
            <Button
              icon="pi pi-chevron-left"
              className="p-button-text p-button-rounded"
              onClick={() =>
                setModalInfo({
                  ...modalInfo,
                  value: Math.max(0, Number(modalInfo.value) - 1),
                })
              }
            />

            {/* Input de número grande */}
            <input
              type="number"
              value={modalInfo.value}
              onChange={(e) =>
                setModalInfo({ ...modalInfo, value: e.target.value })
              }
              className="form-control text-center fw-bold fs-1"
              style={{
                width: "25%",
                border: "none",
                outline: "none",
                boxShadow: "none",
                background: "transparent",
              }}
            />

            {/* Botão de aumentar */}
            <Button
              icon="pi pi-chevron-right"
              className="p-button-text p-button-rounded"
              onClick={() =>
                setModalInfo({
                  ...modalInfo,
                  value: Number(modalInfo.value) + 1,
                })
              }
            />
          </div>

          <p
            className="text-center fst-italic mt-0"
            style={{ fontSize: "0.9rem" }}
          >
            metros quadrados
          </p>

          {/* Botão de salvar */}
          <div className="mt-4 d-flex justify-content-center">
            <Button
              label="SALVAR"
              className="p-button-primary px-5 py-2 fw-bold"
              onClick={() => {
                setDadosEtapa((prev) => ({
                  ...prev,
                  [modalInfo.key]: modalInfo.value,
                }));
                setShowModal(false);
              }}
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default FeasibilityStudy;
